import { Pipe, PipeTransform } from '@angular/core';
import { ExternalGroupedAccount } from '../interfaces';

interface TransformedAccount {
  id: string;
  number: string;
  name: string;
  label: string;
  groupLabel: string;
}

interface GroupedOption {
  label: string;
  items: TransformedAccount[];
}

@Pipe({
  name: 'transformGroupedAccounts',
  standalone: false, // eslint-disable-line
})
export class TransformGroupedAccountsPipe implements PipeTransform {
  transform(groupedAccounts: ExternalGroupedAccount[] | null): GroupedOption[] {
    if (!groupedAccounts) return [];

    return groupedAccounts.map((group) => ({
      label: group.name,
      items: group.accounts
        .filter((account) => !account.attributes.is_disabled)
        .map((account) => ({
          id: String(account.id),
          number: account.attributes.number,
          name: account.attributes.name,
          label: `${account.attributes.number} - ${account.attributes.name}`,
          groupLabel: group.name,
        })),
    }));
  }
}
